import {
  EditableSegment,
  parseEditable,
  findSegmentAt,
} from '../utils/mdEditable';

type Selection = { start: number; end: number };
type LinkPayload = { name: string; href: string };

type LinkInsertResult = {
  value: string;
  caretOffset: number;
  allowed: boolean;
};

export const insertLinkAtSelection = (
  value: string,
  selection: Selection,
  link: LinkPayload,
): LinkInsertResult => {
  if (value.length === 0) {
    const markdown = `[${link.name}](${link.href})`;
    return { value: markdown, caretOffset: markdown.length, allowed: true };
  }

  const segments = parseEditable(value);
  const startSeg = findSegmentAt(segments, selection.start);
  const endSeg = findSegmentAt(segments, selection.end);

  if (!startSeg || !endSeg) {
    return { value, caretOffset: selection.start, allowed: false };
  }

  const normalizedEndSeg = selection.end === startSeg.end ? startSeg : endSeg;

  const sameSeg =
    startSeg === normalizedEndSeg ||
    (startSeg.type === normalizedEndSeg.type &&
      startSeg.start === normalizedEndSeg.start &&
      startSeg.end === normalizedEndSeg.end);

  if (!sameSeg) {
    return { value, caretOffset: selection.start, allowed: false };
  }

  const markdown = `[${link.name}](${link.href})`;

  if (startSeg.type === 'text') {
    const withinSegmentStart = selection.start - startSeg.start;
    const withinSegmentEnd = selection.end - startSeg.start;

    const before = startSeg.value.slice(0, withinSegmentStart);
    const after = startSeg.value.slice(withinSegmentEnd);

    const newSegmentValue = before + markdown + after;
    const newValue =
      value.slice(0, startSeg.start) +
      newSegmentValue +
      value.slice(startSeg.end);

    const caretOffset = startSeg.start + before.length + markdown.length;

    return { value: newValue, caretOffset, allowed: true };
  }

  if (startSeg.type === 'link') {
    const newValue =
      value.slice(0, startSeg.start) + markdown + value.slice(startSeg.end);
    const caretOffset = startSeg.start + markdown.length;
    return { value: newValue, caretOffset, allowed: true };
  }

  return { value, caretOffset: selection.start, allowed: false };
};
